import { ImportedInvestorEntry } from "../../types/ImportedInvestorEntry";
import { SearchableInvestorEntry } from "../../types/SearchableInvestorEntry";

type ValueMask = {
  valueAvailable: boolean;
  field: string;
};

function maskedValue(field: string): ValueMask {
  return {
    valueAvailable: true,
    field,
  };
}

export type FieldAvailable = {
  key: string;
  name: string;
  underlyingField:
    | string
    | ((
        searchableInvestorEntry: SearchableInvestorEntry,
        importedInvestorEntry: ImportedInvestorEntry | null,
        index: number,
      ) => string | ValueMask);
  type: "string" | "number" | "boolean" | "date" | "datetime" | "url" | "email";
  computed?: boolean;
};

const RowIndexField: FieldAvailable = {
  key: "row-index",
  name: "Row Index",
  underlyingField: (_, __, index) => index.toString(),
  type: "number",
  computed: true,
};

const NameField: FieldAvailable = {
  key: "name",
  name: "Name",
  underlyingField: (search, investor) =>
    investor?.fullName ?? search.name ?? "",
  type: "string",
};

const EmailField: FieldAvailable = {
  key: "email",
  name: "Email",
  underlyingField: (search, investor) =>
    (investor?.email ?? search.hasEmail) ? maskedValue("email") : "",
  type: "email",
};

const LinkedInUrlField: FieldAvailable = {
  key: "linkedin",
  name: "LinkedIn URL",
  underlyingField: (search, investor) =>
    (investor?.social?.linkedin ?? search.hasLinkedIn)
      ? maskedValue("linkedin")
      : "",
  type: "url",
};

export function getFieldsAvailable(): FieldAvailable[] {
  return [RowIndexField, NameField, EmailField, LinkedInUrlField];
}
